import BaseLayout from '@/components/BaseLayout.vue'
import { mapGetters } from 'vuex';

export default {
    name: 'home',
    components: {
        BaseLayout,
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
        }),
    }
}